<script setup lang="ts">
  import type { TrainingDetailInstructor } from '@/entities/Training';
  import { formatCivilDateToPtBR } from '@/shared/lib';
  import { buildInstructorNameLabel } from '../../lib/buildInstructorNameLabel';
  import { TRAINING_EMPTY_VALUE } from '../../lib/trainingEmptyValue';

  defineProps<{ instructors: TrainingDetailInstructor[] }>();
</script>

<template>
  <div
    data-testid="view-training-instructors-list"
    class="flex flex-col gap-4"
  >
    <div
      v-for="instructor in instructors"
      :key="instructor.sessionId"
      data-testid="view-training-instructor-row"
      class="flex flex-wrap gap-4"
    >
      <div class="flex w-full flex-col gap-2 md:w-67">
        <span class="text-sm font-semibold text-gray-07">Ministrante:</span>
        <span
          class="rounded-2xl border border-border-color bg-gray-02/20 px-5 py-3 text-sm text-gray-07"
        >
          {{ buildInstructorNameLabel(instructor) }}
        </span>
      </div>
      <div class="flex w-full flex-col gap-2 md:w-80">
        <span class="text-sm font-semibold text-gray-07">Cargo:</span>
        <span
          class="rounded-2xl border border-border-color bg-gray-02/20 px-5 py-3 text-sm text-gray-07"
        >
          {{ instructor.position?.name ?? TRAINING_EMPTY_VALUE }}
        </span>
      </div>
      <div class="flex w-full flex-col gap-2 md:w-45">
        <span class="text-sm font-semibold text-gray-07">Data do treinamento:</span>
        <span
          class="rounded-2xl border border-border-color bg-gray-02/20 px-5 py-3 text-sm text-gray-07"
        >
          {{ instructor.trainingDate ? formatCivilDateToPtBR(instructor.trainingDate) : TRAINING_EMPTY_VALUE }}
        </span>
      </div>
    </div>
    <p
      v-if="instructors.length === 0"
      data-testid="view-training-instructors-empty"
      class="text-sm text-gray-05"
    >
      Nenhum ministrante vinculado ao treinamento
    </p>
  </div>
</template>
